import { Suspense } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AdminLayouts from "../layouts/AdminLayout";
import DefaultLayout from "../layouts/DefaultLayout";
import Login from "../pages/Login";
import PrivateRoute from "../layouts/PrivateRoute";
import SignUp from "pages/signup/singup";
import Dashboard from "pages/dashboard/Dashboard";
import EmployeesList from "pages/Employees/EmployeesList";
import ProductList from "pages/Products/ProductList";
import FarmersList from "pages/Farmers/FarmersList";
import CropList from "pages/Crops/CropList";
import DistributorsList from "pages/Distributors/DistributorsList";
import ReportList from "pages/report/ReportList";
import DemoReport from "pages/summary/DemoReport";
import VisitReport from "pages/summary/VisitReport";
import UploadLogo from "pages/documents/UploadLogo";
import HelpPage from "pages/help/HelpPage";

export default function Routers() {
  // onForegroundMessage((payload: any) => {
  //   showToast(payload.notification.title, "info");
  // });
  return (
    <Suspense fallback={<h1>loading</h1>}>
      <Router
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <Routes>
          <Route element={<DefaultLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
          </Route>

          <Route path="/admin" element={<PrivateRoute Layout={AdminLayouts} />}>
            <Route path="dashboard" element={<Dashboard />} />

            <Route
              path="employees"
              element={<EmployeesList></EmployeesList>}
            ></Route>
            <Route
              path="products"
              element={<ProductList></ProductList>}
            ></Route>
            <Route path="farmers" element={<FarmersList></FarmersList>}></Route>
            <Route path="crops" element={<CropList></CropList>}></Route>
            <Route
              path="distributors"
              element={<DistributorsList></DistributorsList>}
            ></Route>
            <Route path="report" element={<ReportList></ReportList>}></Route>
            <Route path="demo" element={<DemoReport></DemoReport>} />
            <Route path="visit" element={<VisitReport></VisitReport>} />
            <Route path="upload" element={<UploadLogo></UploadLogo>} />
            <Route path="help" element={<HelpPage></HelpPage>} />
          </Route>

          <Route path="/*" element={<Navigate to="/login" replace={true} />} />
        </Routes>
      </Router>
    </Suspense>
  );
}
